import { schema } from 'normalizr';
import { Space } from 'api/space/space';
// import { spaceTabSchema } from 'data/spaces';
import { Sprint } from 'api/sprint-planning/types';
import { SchemaKeys } from 'data/core';
import { taskSchema } from 'data/tasks/schema';

const sprintSchema = new schema.Entity<Sprint>(
  SchemaKeys.Sprints,
  {},
  {
    idAttribute: 'sprintId',
  },
);

export const projectPhaseSchema = new schema.Entity(
  'projectPhases',
  { tasks: [taskSchema], sprints: [sprintSchema] },
  { idAttribute: 'projectPhaseId' },
);

// NOTE:: Customising it here since templates uses `spaceList` instead of `spaces`
const spaceSchema = new schema.Entity<Space>(
  'spaceList',
  {
    // spaceTabs: [spaceTabSchema],
  },
  {
    idAttribute: (value: Space) => String(value.spaceId),
    processStrategy: (entity: Space) => {
      return entity.spaceTabs
        ? // Checking private coz a bug came where private was not being sent to the BE
          // https://northstar.nitro.run/projects/4895/plan#task_drawer=4895.3960823&task_drawer_tab=conversations
          { ...entity, private: entity?.private === true }
        : { ...entity, private: entity?.private === true, spaceTabs: [] };
    },
  },
);

export const templateSchema = new schema.Entity(
  'template',
  {
    templateContent: {
      projectPhases: [projectPhaseSchema],
      sprints: [sprintSchema],
      spaceList: [spaceSchema],
    },
  },
  {
    idAttribute: 'templateId',
  },
);
